import _styled from "styled-components";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import Spacing from "../../../../Styled/Spacing";
import * as DTP from "./DateTimePickerStyles";
import { monthNames } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DayView = _ref => {
  let {
    year,
    month,
    datesObject,
    selectedDay,
    onSelectDay,
    onBackToYear,
    onBackToMonth
  } = _ref;
  const {
    t
  } = useTranslation();
  const dayObject = datesObject;
  if (!dayObject || dayObject.dates.length <= 1) {
    return null;
  }
  const daysToDisplay = dayObject.dates;
  const selected = selectedDay ? dayObject[selectedDay].dates[0] : null;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(DTP.BackButton, {
        title: t("dateTime.back"),
        onClick: onBackToYear,
        children: year
      }), "\xA0", /*#__PURE__*/_jsx(DTP.BackButton, {
        title: t("dateTime.back"),
        onClick: onBackToMonth,
        children: monthNames[month]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 1
      })]
    }), /*#__PURE__*/_jsx(DatePicker, {
      inline: true,
      onChange: onSelectDay,
      includeDates: daysToDisplay,
      selected: selected
    })]
  });
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "DayView___StyledDiv",
  componentId: "sc-9baq6o-0"
})(["text-align:center;margin-top:-10px;"]);